export default __webpack_public_path__ + "static/media/lysningen-property-03.83e40169.jpg";